import React from 'react';
import PropTypes from 'prop-types';
import { TextStyle } from '@lavu-pos/lavu-react-components';
import { Colors } from 'modules/utils';
import { useIntl } from 'react-intl';

const propTypes = {
	expand: PropTypes.bool,
	onClick: PropTypes.func,

	elementId: PropTypes.string,
};
const defaultProps = {
	onClick: () => {},
	expand: true,
};

const ExpandAndCollapse = ({
	expand,
	onClick,

	elementId,
}) => {
	const { messages } = useIntl();
	return (
		<button
			onClick={onClick}
			type="button"
			style={{
				background: 'transparent',
				border: 'none',
				cursor: 'pointer',
			}}
			id={elementId}
		>
			<TextStyle fontSize={12} fontWeight="600" color={Colors.PRIMARY_TEXT}>
				{expand ? messages.expandAll : messages.collapseAll}
			</TextStyle>
		</button>
	);
};
ExpandAndCollapse.propTypes = propTypes;
ExpandAndCollapse.defaultProps = defaultProps;

export default ExpandAndCollapse;
